import type { AreaCatalog } from '../area';
import type { suggestions as en } from '../en/suggestions';

export const suggestions = {
  'suggestions.door.redate': 'Neu datieren',
  'suggestions.door.deliver': 'Fertig',
  'suggestions.door.active': 'Aktiv',
  'suggestions.door.idle': 'Ruhend',
  'suggestions.door.revisit': 'Überdenken',
  'suggestions.door.reopen': 'Wieder öffnen',
  'suggestions.door.contain': 'Nicht betroffen',
} as const satisfies AreaCatalog<typeof en>;
